import React from 'react'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import Reboot from 'material-ui/Reboot'

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme({
  
  palette: {    
    primary: {
      light: "#ff5f52",
      main: "#c62828",
      
      dark: "#8e0000",
      contrastText: "#ffffff"
    },
    secondary: {
      main: '#f9a825',
      light: '#ffd95a',
      dark: '#c17900',
      contrastText: "#000000"
    },
  },
  fontFamily: 'Kanit',
  typography: {
    fontFamily: 'Kanit'
  }
})

function withRoot(Component) {
  function WithRoot(props) {
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <MuiThemeProvider theme={theme}>
        {/* Reboot kickstart an elegant, consistent, and simple baseline to build upon. */}
        <Reboot />
        <Component {...props} />
      </MuiThemeProvider>
    )
  }

  return WithRoot
}

export default withRoot


// WEBPACK FOOTER //
// ./src/withRoot.js